/**
 * 数值输入动画
 */
import fvAnimation from "./fvAnimation"
export default class fvVarInput extends fvAnimation {
    constructor(shape){
        super(shape,"fvVarInput");
        this.sizeFunction = AsyncFunction("return " + this.expression);
        this.shape = shape;
        this.time = 100;
    }

    ok(value){
        //判断如果是数据库变量， 那就进入判断，看是否有权限
        if(this.fvScript.system.$.dbCom.isDbVar(this.expression)){
            //this.time = 2000;
            //下值到设备 232
            this.fvScript.SetDbVar(this.expression,value,232)
        }else{
            //如果是中间变量直接赋值
            //this.time = 0;
            Function(this.expression + "=" + value)();
        }
    }

    async run(event,value){
        if(value == false) return;
        var size = await this.executionScript(this.sizeFunction);
        //左键单击事件
        if(event.button == 0 && "down" == this.getEventType(event.type)){
            if(typeof size != "number"){
                return;
            }
            this.value = size;
            //函数在fvAnimation.js中声明
            this.dialog.show({
                data : { 
                    ok : this.ok,
                    value : size,
                },
                okText:this.fvScript.system.$.getResource('确定') || "确定",
                cancelText: this.fvScript.system.$.getResource('取消') || "取消",
                title: this.tagName,
                loading: true,
                render: (h) => {
                    return h('InputNumber', {
                        style : "width: 100%",
                        props: {
                            
                            value: size,
                            autofocus: true,
                            placeholder: this.fvScript.system.$.getResource('请输入要设置的数值') || "请输入要设置的数值",
                        },
                        on: {
                            input: (val) => {
                                this.value = val;
                            }
                        }
                    })
                },
                onOk: () => {
                    this.ok(this.value);
                    //异步请求关闭窗口
                    this.dialog.$Modal.remove();
                    // setTimeout(() => {
                    //     this.dialog.$Modal.remove();
                    // }, this.time);
                }
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvVarInput.js